export default __webpack_public_path__ + "static/media/gravatar.fbfe03c2.png";